import {DateTime} from 'luxon';
import {Text, View, WarningIcon} from 'native-base';
import React from 'react';

enum ExpiryState {
  SOON = 'SOON',
  FUTURE = 'FUTURE',
  EXPIRED = 'EXPIRED',
}

const getExpiryDate = (start: string, end: string) => {
  const endDateTime = DateTime.fromISO(end).toLocal();
  const startDateTime = DateTime.fromISO(start).toLocal();
  const formattedEnd = endDateTime.toFormat('MM.dd.yy');
  const now = DateTime.local();
  const {days: remainingDays} = endDateTime.diff(now, 'days');
  const formattedStart = startDateTime.toFormat('MM.dd.yy');

  if (startDateTime > now) {
    return {
      state: ExpiryState.FUTURE,
      text: `${formattedStart} - ${formattedEnd}`,
    };
  }

  if (endDateTime < now) {
    return {state: ExpiryState.EXPIRED, text: 'Expired'};
  }

  if (endDateTime.hasSame(now, 'day')) {
    return {state: ExpiryState.SOON, text: 'Expires today'};
  }

  if (endDateTime.hasSame(now.plus({days: 1}), 'day')) {
    return {state: ExpiryState.SOON, text: 'Expires tomorrow'};
  }
  if (remainingDays < 6) {
    return {
      state: ExpiryState.SOON,
      text: `Expires in ${Math.floor(remainingDays)} days`,
    };
  }

  return {
    state: ExpiryState.FUTURE,
    text: `${formattedStart} - ${formattedEnd}`,
  };
};

const OfferExpirationDate: React.FC<{
  endDate: string;
  startDate: string;
  size: number;
  lineHeight?: number;
}> = ({endDate, size, lineHeight = 20, startDate}) => {
  const {state, text} = getExpiryDate(startDate, endDate);
  const isFuture = state === ExpiryState.FUTURE;
  const isExpired = state === ExpiryState.EXPIRED;
  const title = isFuture ? 'Valid ' : '';

  return (
    <View
      testID="offer-expiration-date"
      flexDirection="row"
      justifyContent="center"
      alignItems="center">
      {[ExpiryState.SOON, ExpiryState.EXPIRED].includes(state) && (
        <WarningIcon
          color={isExpired ? 'error' : 'info'}
          size={`${size}px`}
          marginRight="5px"
        />
      )}
      <Text
        testID="offer-expiration-date-text"
        fontSize={`${size}px`}
        color={isExpired ? 'error' : 'info'}
        textAlign="center"
        fontWeight={700}
        lineHeight={`${lineHeight}px`}>
        {`${title}${text}`}
      </Text>
    </View>
  );
};

export default OfferExpirationDate;
